<template>
  <div>
    <el-dialog title="批量导入项目" :visible.sync="batchVisible" width="700px" :before-close="handleClose" :close-on-click-modal="false" center>
      <div class="from-body">
        <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="auto" class="demo-ruleForm">
          <div style="font-weight:bold;margin-top:15px;">建筑类型</div>
          <div class="form-radio-box" style="margin-top:10px;">
            <div class="form-radio">
              <el-radio-group v-model="buildRadioParent" size="small" @input="handleRadioParent">
                <el-radio-button label="civilBuild">民用住宅</el-radio-button>
                <el-radio-button label="commercialBuild">商用建筑</el-radio-button>
                <el-radio-button label="publicBuild">公用建筑</el-radio-button>
              </el-radio-group>
            </div>
            <div class="form-radio-group" style="margin-top:5px;">
              <el-form-item label-width="auto" prop="buildingType">
                <el-radio-group v-model="ruleForm.buildingType">
                  <el-radio :label="i.id" v-for="i in buildList" :key="i.id">{{ i.name }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <el-form-item label="项目名称" prop="projectName" style="width: 100%">
              <el-input
                v-model.trim="ruleForm.projectName"
                clearable
                maxlength="64"
                placeholder="请输入"
              />
            </el-form-item>
          <div style="margin-top:5px;">
            <el-form-item label="项目状态" prop="status">
              <el-select v-model="ruleForm.status" style="width: 100%" clearable>
                <el-option label="在建" :value="10" />
                <el-option label="试运行" :value="20" />
                <el-option label="已交付" :value="30" />
              </el-select>
            </el-form-item>
            <el-form-item label="所属组织" prop="orgId">
              <el-cascader
                :options="orgList"
                :props="orgProps"
                v-model="ruleForm.orgId"
                style="width: 100%"
                clearable
                placeholder="请选择"
              />
            </el-form-item>
            <el-form-item label="所在省份" prop="province" style="width: 100%">
              <el-select
                v-model="ruleForm.province"
                style="width: 100%"
                @change="provinceChange"
                filterable
                clearable
                placeholder="请选择省"
                @clear="clearProvince"
              >
                <el-option
                  v-for="(item, index) in provinceList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="所在城市" prop="city" style="width: 100%">
              <el-select
                v-model="ruleForm.city"
                style="width: 100%"
                filterable
                clearable
                placeholder="请选择市"
              >
                <el-option
                  v-for="(item, index) in cityList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="系统类型" prop="systemType">
              <el-select
                v-model="ruleForm.systemType"
                style="width: 100%"
                filterable
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in systemTypeList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"/> 
              </el-select>
            </el-form-item> 
            <el-form-item label="导入文件" prop="excel">
              <DiluUploadFile accept=".xls,.xlsx"  :limit="1" :fileList="fileList" :excelFile="excelFile" :fileName="fileName"  @remove="removeFile" @success="successFile" />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" style="margin-bottom:20px;">
        <el-button type="primary" @click="submit" style="width:600px;">批 量 导 入</el-button>
      </div>
    </el-dialog>
    <!-- 错误详情 -->
    <el-dialog title="错误详情" :visible.sync="errVisible" width="600px" height="600px" padding-top="10px" style="overflow-y:auto;">
      <json-viewer :value="jsonData" :expand-depth=3 :preview-mode="true" :show-array-index="false" style="height:600px;overflow-y:auto;" show-double-quotes copyable/>
    </el-dialog>
  </div>
</template>

<script lang="js">
import build from "../js/build";
import systemTypeList from "../js/systemType";
import DiluUploadFile from "@/components/public/dilu-uploadfile.vue";
export default {
  name: 'BatchCreate',
  props: ["batchVisible"],
  components: {DiluUploadFile},
  data() {
    return {
      jsonData: [],
      errVisible: false,
      buildRadioParent: "civilBuild",
      orgList: [],      // 归属组织
      buildList: [],    // 建筑列表
      province: "",     // 当前省份
      city: "",         // 当前城市
      provinceList: [], // 省份列表
      cityList: [],     // 城市列表
      systemTypeList,   // 系统类型
      buildingType: "", // 建筑类型
      fileList: [],     // 导入文件
      excelFile: "https://res-more.deebike.com/other/batchcreate0619.xlsx",  //批量导入项目模板
      fileName: "批量导入项目",
      orgProps: {
        children: "orgList",
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      rules: {
        buildingType: [
          { required: true, message: "请选择建筑类型", trigger: "change" }
        ],
        status: [
          { required: true, message: "请选择项目状态", trigger: "change" }
        ],
        orgId: [
          { required: true, message: "请选择所属组织", trigger: "change" }
        ],
        projectName: [
          { required: true, message: "请设置项目名称", trigger: "change" }
        ],
        province: [
          { required: true, message: "请选择省", trigger: "change" }
        ],
        city: [
          { required: true, message: "请选择市", trigger: "change" }
        ],
        systemType: [
          { required: true, message: "请选择系统类型", trigger: "change" }
        ],
        excel: [
          { required: true, message: "请上传导入文件", trigger: "change" }
        ]
      },
      ruleForm: {
        flag: "batchCreate",
        buildingType: null, // 建筑类型
        status: 10,      //项目状态 10：在建，20：试运行，30：已交付
        orgId: "",       //所属组织
        projectName: "", //项目名称
        country: "中国", //国家
        province: "",   //省份id
        provinceName:"",//省份名称
        city: "",       //城市id
        cityName: "",   //城市名称
        systemType: "", //系统类型
        excel: "",      //导入文件
      }
    }
  },
  watch: {
    batchVisible(newVal) {
      if (newVal) {
        this.listOrg();
        this.getProvince();
        this.handleRadioParent();
      }
    },
  },
  methods: {
    removeFile(e) {
      const i = this.fileList.findIndex((x) => x.name == e);
      this.fileList.splice(i, 1);
      this.ruleForm.excel = null;
    },
    successFile(e) {
      this.ruleForm.excel = e.url;
      this.fileList = e.fileList;
    },
    setBuildList() {
      this.buildList = build[this.buildRadioParent].typeList;
    },
    handleRadioParent() {
      this.ruleForm.buildingType = null;
      this.setBuildList();
    },
    listOrg() {
      this.request.listOrg().then((res) => {
        if (res.code == 0) {
          this.orgList = [res.data];
        }
      });
    },
    getProvince() {
      this.request.getProvince().then((res) => {
        this.provinceList = res.data;
      });
    },
    getCity() {
      let params = {};
      params["province"] = this.ruleForm.province;
      this.request.getCity(params).then((res) => {
        this.cityList = res.data;
      });
    },
    provinceChange(value) {
      for (let item of this.provinceList) {
        if (item["name"] == value) {
          this.province = item["id"];
        }
      }
      this.getCity();
    },
    clearProvince() {
      this.ruleForm.city = "";
    },
    handleClose() {
      this.$emit("handleClose");
    },
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          const buildingType=this.ruleForm.buildingType;
          this.ruleForm.buildingType=[build[this.buildRadioParent].id, buildingType];
          const province = this.ruleForm.province;
          const city = this.ruleForm.city;
          const findProvince = this.provinceList.find(i => i.id === province);
          const findCity = this.cityList.find(i => i.id === city);
          this.ruleForm.provinceName = findProvince ? findProvince.name : "";
          this.ruleForm.cityName = findCity ? findCity.name : "";
          this.request.batchCreate(this.ruleForm).then((res) => {
            if (res.code == 0) {
              if (JSON.stringify(res.data)=="{}") {
                this.$message.success(res.msg);
                this.handleClose();
              } else {
                this.jsonData=res.data;
                this.errVisible=true;
              }
            }
          });
        }
      });
    },
  }
}

</script>
<style scoped lang="scss">
.from-body {
  padding: 0 60px;
  box-sizing: border-box;
}
.areaBox {
  display: flex;
  justify-content: flex-start;
}
</style>